import { useEffect, useState } from "react";
import { Star, Ban } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "../lib/api";

const VARIANTS = {
  preferred: { Icon: Star, color: "text-[#C9962E]", title: "Agents préconisés sur ce site", hint: "Ils apparaissent en premier lors de l'affectation des vacations et sont prioritaires au remplissage automatique.", id: "preferred" },
  banned: { Icon: Ban, color: "text-rose-600", title: "Agents interdits sur ce site", hint: "Ils ne peuvent pas être affectés au planning de ce site (seul l'administrateur peut forcer, avec un motif) et sont exclus des messages groupés.", id: "banned" },
};

export const PreferredAgentsField = ({ value = [], onChange, variant = "preferred" }) => {
  const V = VARIANTS[variant];
  const [agents, setAgents] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { http.get("/agents").then((r) => setAgents(r.data.filter((a) => !a.archived))).catch((e) => toast.error(formatApiError(e))); }, []);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  const shown = agents.filter((a) => `${a.last_name} ${a.first_name}`.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => (value.includes(b.id) - value.includes(a.id)) || a.last_name.localeCompare(b.last_name));
  return (
    <div data-testid={`site-${V.id}-agents`}>
      <div className="text-[11px] font-bold uppercase tracking-widest text-slate-500 mb-1 flex items-center gap-1"><V.Icon className={`h-3.5 w-3.5 ${V.color}`} />{V.title} ({value.length})</div>
      <p className="text-xs text-slate-500 mb-2">{V.hint}</p>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un agent" className="input mb-2" data-testid={`${V.id}-search`} />
      <div className="max-h-44 overflow-y-auto border border-slate-200 rounded-md divide-y divide-slate-100">
        {shown.map((a) => (
          <label key={a.id} className="flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
            <input type="checkbox" checked={value.includes(a.id)} onChange={() => toggle(a.id)} data-testid={`${V.id}-${a.id}`} />
            {a.last_name} {a.first_name}{a.subcontractor_id && <span className="text-[10px] text-slate-500">(sous-traitant)</span>}
          </label>
        ))}
      </div>
    </div>
  );
};

export const sortForSite = (agents, site, subs = []) => {
  const pref = site?.preferred_agent_ids || [];
  const subName = Object.fromEntries(subs.map((s) => [s.id, s.name]));
  const label = (a) => `${pref.includes(a.id) ? "★ " : ""}${a.last_name} ${a.first_name}${a.subcontractor_id ? ` — ST ${subName[a.subcontractor_id] || ""}` : ""}`;
  const rank = (a) => (pref.includes(a.id) ? 0 : a.subcontractor_id ? 2 : 1);
  return [...agents].sort((a, b) => rank(a) - rank(b) || a.last_name.localeCompare(b.last_name)).map((a) => ({ ...a, _label: label(a) }));
};
